/*
 * @描叙: 机房API 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-05-23 14:58:23 
*/

import { $post, $get, $delete} from '@/utils/http'
import Service from './Service'

// 获取项目下机房监控信息
Service.getServerroombypid = async function () {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    let data = await $get('/ucenter/v2/map/serverroombypid', request, true);
    return Service.handleCommonError(data)
}

// 	添加机房组态
Service.addSenceMap = async function (params) {
    // 项目Id
    params['assigned_project_id'] = Service.getProjectSystemId();
    if (!params['assigned_project_id']) return;

    let data = await $post('/ucenter/v2/map/addserverroom', params, true);
    return Service.handleCommonError(data)
}

// 编辑
Service.editMapServerroom = async function (params) {
    let data = await $post('/ucenter/v2/map/editserverroom', params, true);
    return Service.handleCommonError(data)
}

// 删除
Service.deleteMapServerroom = async function (params) {
    let data = await $post('/ucenter/v2/map/delserverroom', params, true);
    return Service.handleCommonError(data)
}

// 删除机房监控信息
Service.delServerroom = async function (params) {
    let request = {}
    // Id
    request['oid'] = params.oid;

    let data = await $post('/ucenter/v2/map/delserverroom', request);
    return Service.handleCommonError(data)
}

// 添加PLC型号  	/ucenter/v2/device/addplctype
Service.addPlcType = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 	plc型号名
    request['type_name'] = params.type_name

    let data = await $post('/ucenter/v2/device/addplctype', request, true);
    return Service.handleCommonError(data)
}

// 修改PLC型号
Service.editplctype = async function (params) {
    let request = {}

    // 	plc OID
    request['oid'] = params.oid
    // 	plc型号名
    request['type_name'] = params.type_name

    let data = await $post('/ucenter/v2/device/editplctype', request, true);
    return Service.handleCommonError(data)
}

// 按PLC型号ID删除PLC型号
Service.delplctype = async function (params) {
    let request = {}

    // 	plc OID
    request['oid'] = params.oid

    let data = await $post('/ucenter/v2/device/delplctype', request, true);
    return Service.handleCommonError(data)
}

// 按项目id获取PLC型号
Service.getPlcTypebypid = async function () {
    let request = {}

    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    request['page_num'] = 1;

    request['page_sum'] = 100;

    let data = await $get('/ucenter/v2/device/plctypebypid', request, true);
    return Service.handleCommonError(data)
}

// 获取PLC型号配置
Service.getPlcConfig = async function (params) {
    let request = {}

    // 	plc OID
    request['terminal_id'] = params.terminal_id

    request['var_Initial_addr'] = params.var_Initial_addr || -1

    request['page_num'] = params.page_num;

    request['page_sum'] = params.page_sum;
    
    let data = await $get('/ucenter/v2/device/plcconfigurationbytypeid', request, true);
    return Service.handleCommonError(data)
}

// 按PLC型号配置ID获取
Service.getPlcConfigInfo = async function (params) {
    let request = {}

    // 	plc OID
    request['oid'] = params.oid

    let data = await $get('/ucenter/v2/device/plcconfiguration', request, true);
    return Service.handleCommonError(data)
}

// 添加PLC型号
Service.addPlcConfiguration = async function (params) {

    let data = await $post('/ucenter/v2/device/addplcconfiguration', params, true);
    return Service.handleCommonError(data)
}

// 单个删除
Service.delPlcConfiguration = async function (params) {

    let data = await $post('/ucenter/v2/device/delplcconfiguration', params, true);
    return Service.handleCommonError(data)
}

// 批量删除
Service.delPlcConfigurationSome = async function (params) {
	var formData = new FormData();
	formData.append("oidlist", JSON.stringify(params.oidlist));
    let data = await $delete('/ucenter/v2/device/plcconfiguration/idlist', formData, true);
    return Service.handleCommonError(data)
}

// 全部删除
Service.delPlcConfigurationAll = async function (params) {


    var formData = new FormData();
    formData.append("terminal_id", JSON.stringify(params.terminal_id));

    // let data = await $delete(BASEURL + "", formData, true);
    // return Service.handleCommonError(data)
	
    let data = await $delete('/ucenter/v2/device/plcconfiguration/termianlid', formData, true);
    return Service.handleCommonError(data)
}

// Service.deleteProjectSystem = async function (params) {
//     // let request = {}
//     // // 	项目子系统ID
//     // request['oid'] = params.oid;
//     // let data = await $delete(_url.detele, request);
    
	
//     var formData = new FormData();
//     formData.append("oid", params.oid);

//     let data = await $delete(_url.detele + '', formData);
// 	return Service.handleCommonError(data)
	
// }
// 编辑
Service.editPlcConfiguration = async function (params) {

    let data = await $post('/ucenter/v2/device/editplcconfiguration', params, true);
    return Service.handleCommonError(data)
}

// 设置PLC数据点表
Service.setPlcConfiguration = async function (params) {

    let data = await $post('/ucenter/v2/device/plcconfiguration', params, true);
    return Service.handleCommonError(data)
}
//批量设置PLC数据点表
Service.setPlcConfigurationSome = async function (params) {
	let request={}
	request['terminal_id']=params.terminal_id;
	request['oidlist']=JSON.stringify(params.oidlist);
    let data = await $post('/ucenter/v2/device/plcconfiguration/idlist', request, true);
    return Service.handleCommonError(data)
}
// 获取PLC的曲线图
Service.getPlcCurve = async function (params) {

    let data = await $get('/ucenter/v2/device/plccurve', params, true);
    return Service.handleCommonError(data)
}

// 	添加机房参数信息
Service.addServerroom = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    request['terminal_id'] = params.terminal_id;

    request['setting_data'] = params.setting_data;

    request['setting_type'] = params.setting_type;

    let data = await $post('/ucenter/v2/devices/addserverroom', request, true);
    return Service.handleCommonError(data)
}

// 	修改机房参数信息
Service.editServerroom = async function (params) {
    let request = {}

    request['oid'] = params.oid;

    request['setting_data'] = params.setting_data;

    let data = await $post('/ucenter/v2/devices/editserverroomdata', params, true);
    return Service.handleCommonError(data)
}

// 	删除机房参数
Service.delServerroom = async function (params) {
    let request = {}

    request['oid'] = params.oid;

    let data = await $post('/ucenter/v2/devices/delserverroom', params, true);
    return Service.handleCommonError(data)
}

// 获取项目下机房参数配置信息
Service.getServerRoombypid = async function () {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    let data = await $get('/ucenter/v2/devices/serverroombypid', request, true);
    return Service.handleCommonError(data)
}

// 读取或控制特定addr变量
Service.controlPlcinteraction = async function (params) {
    let request = {}

    request['terminalid'] = params.terminalid;

    request['opcode'] = params.opcode;

    request['addrstart'] = params.addrstart;

    request['value'] = params.value;

    let data = await $post('/ucenter/v2/devices/controlplcinteraction', request);
    return Service.handleCommonError(data)
}

// PLC配置地址导出
Service.exportPlcConfig = async function (params) {
    let request = {}

    request['terminal_id'] = params.terminalid;

    let data = await $get('/ucenter/v2/device/getplcconfigurationexport', request);
    return Service.handleCommonError(data)
}

// PLC配置地址导入
Service.importPlcConfig = async function (params) {
    let request = {}

    request['terminal_id'] = params.terminalid;

    request['file_path'] = params.file_path;

    let data = await $post('/ucenter/v2/device/getplcconfigurationinport', request);
    return Service.handleCommonError(data)
}

// 获取最新PLC数据
Service.getPlcCurrentReadings = async function (params) {
    let request = {}
    // plc表记id
    request['oid'] = params.oid;

    // let data = await $get('/ucenter/v2/devices/plccurrentreadingsbytid', request);
    let data = await $get('/ucenter/v2/devices/plccurrentreadingsbytidfromredis', request);   // 改
    return Service.handleCommonError(data)
}
// 获取多个最新PLC数据
Service.getmorePlcCurrentReadings = async function (params) {
    let request = {}
    // plc表记id
    request['terminalidlist'] = params.terminalidlist;

    // let data = await $get('/ucenter/v2/devices/plccurrentreadingsbytid', request);
    let data = await $get('/ucenter/v2/devices/plccurrentreadingsbytidsfromredis', request);   // 改
    return Service.handleCommonError(data)
}

// PLC 报表导出接口
Service.getPlcExport = async function (params) {
    let data = await $post('/ucenter/v2/device/plccurve/export', params);
    return Service.handleCommonError(data)
}

// 添加plc子设备
Service.addPlcTerminal = async function (params) {
    let data = await $post('/ucenter/v2/device/plcterminal/add', params);
    return Service.handleCommonError(data)
}

// 修改plc子设备
Service.editPlcTerminal = async function (params) {
    let data = await $post('/ucenter/v2/device/plcterminal/edit', params);
    return Service.handleCommonError(data)
}

// 删除plc子设备
Service.delPlcTerminal = async function (params) {
    let data = await $post('/ucenter/v2/device/plcterminal/del', params);
    return Service.handleCommonError(data)
}

// 获取plc子设备
Service.getPlcTerminal = async function (params) {
    let data = await $get('/ucenter/v2/device/plcterminal/tid', params);
    return Service.handleCommonError(data)
}

// 获取机房统计数据
Service.getStatisticsData = async function (params = {}) {
    // 项目Id
    params['assigned_project_id'] = Service.getProjectSystemId();
    if (!params['assigned_project_id']) return;

    let data = await $get('/ucenter/v2/device/plcterminalstatisticbypid', params);
    return Service.handleCommonError(data)
}

// 获取机房统计数据
Service.getPlcConfiguration = async function (params) {
    
    let data = await $post('/ucenter/v2/device/plcconfigurationbyidlist', params);
    return Service.handleCommonError(data)
}

// 获取机房日统计数据
Service.getPlcdayElectricity = async function (params = {}) {
    // 项目Id
    params['assigned_project_id'] = Service.getProjectSystemId();
    if (!params['assigned_project_id']) return;
    let data = await $get('/ucenter/v2/device/plcdailyelectricitybypidV3', params);
    return Service.handleCommonError(data)
}

// 节能基数
// 获取项目id下的节能配置
Service.getEnergyConfig = async function (params = {}) {
    // 项目Id
    params['project_id'] = Service.getProjectSystemId();
    if (!params['project_id']) return;
    params['page_num'] = 1;

    params['page_sum'] = 100;

    let data = await $get('/ucenter/v2/device/energyconservation/bypid', params);
    return Service.handleCommonError(data)
}

// 获取项目id下的节能配置
Service.getEnergyConfigBytype = async function (params = {}) {
    // 项目Id
    params['project_id'] = Service.getProjectSystemId();
    if (!params['project_id']) return;
    let data = await $get('/ucenter/v2/device/energyconservation/byplcterminaltype', params);
    return Service.handleCommonError(data)
}

// 增加
Service.addEnergyConfig = async function (params) {
    // 项目Id
    params['project_id'] = Service.getProjectSystemId();
    if (!params['project_id']) return;
    let data = await $post('/ucenter/v2/device/energyconservation/add', params);
    return Service.handleCommonError(data)
}
// 删除
Service.delEnergyConfig = async function (params) {

    let data = await $post('/ucenter/v2/device/energyconservation/del', params);
    return Service.handleCommonError(data)
}
// 修改
Service.editEnergyConfig = async function (params) {

    let data = await $post('/ucenter/v2/device/energyconservation/edit', params);
    return Service.handleCommonError(data)
}

// plc电量计费规则
// 添加
Service.addElectricityRule = async function (params) {
    // 项目Id
    params['project_id'] = Service.getProjectSystemId();
    if (!params['project_id']) return;
    let data = await $post('/ucenter/v2/device/electricitystatisticrule/add', params);
    return Service.handleCommonError(data)
}

// 删除
Service.delElectricityRule = async function (params) {

    let data = await $post('/ucenter/v2/device/electricitystatisticrule/del', params);
    return Service.handleCommonError(data)
}
// 修改
Service.editElectricityRule = async function (params) {

    let data = await $post('/ucenter/v2/device/electricitystatisticrule/edit', params);
    return Service.handleCommonError(data)
}

// 获取
Service.getElectricityRule = async function (params = {}) {
    // 项目Id
    params['project_id'] = Service.getProjectSystemId();
    if (!params['project_id']) return;
    let data = await $get('/ucenter/v2/device/electricitystatisticrule/pid', params);
    return Service.handleCommonError(data)
}

// 水泵节能配置
// 添加
Service.addPumpsEnergy = async function (params) {
    // 项目Id
    params['project_id'] = Service.getProjectSystemId();
    if (!params['project_id']) return;
    let data = await $post('/ucenter/v2/device/pumpsenergyconservation/add', params);
    return Service.handleCommonError(data)
}

// 删除
Service.delPumpsEnergy = async function (params) {

    let data = await $post('/ucenter/v2/device/pumpsenergyconservation/del', params);
    return Service.handleCommonError(data)
}
// 修改
Service.editPumpsEnergy = async function (params) {

    let data = await $post('/ucenter/v2/device/pumpsenergyconservation/edit', params);
    return Service.handleCommonError(data)
}

// 获取
Service.getPumpsEnergy = async function (params) {
    // 项目Id
    params['project_id'] = Service.getProjectSystemId();
    if (!params['project_id']) return;
    let data = await $get('/ucenter/v2/device/pumpsenergyconservation/pid', params, true);
    return Service.handleCommonError(data)
}

// 获取机房参数分组配置
Service.getMachineVarConfig = async function () {
    return [
        {
            label: '压力记录配置',
            value: 1
        },
        {
            label: '温度记录配置',
            value: 2
        },
        {
            label: '设备工况配置',
            value: 3
        },
        {
            label: '供回水温配置',
            value: 4
        },
        {
            label: '故障设置',
            value: 5
        },
        {
            label: '温度设置',
            value: 6
        },
        {
            label: '压差设置',
            value: 7
        },
        {
            label: '延时设置',
            value: 8
        },
        {
            label: '频率设置',
            value: 9
        },
        {
            label: '电能报表配置',
            value: 10
        },
        {
            label: '流量记录配置',
            value: 11
        },
        {
            label: '能效记录配置',
            value: 12
        },
        {
            label: '高级参数设置',
            value: 20
        },
    ]
}

// 获取节能概况
Service.getEnergyConservation = async function (params = {}) {
    // 项目Id
    params['assigned_project_id'] = Service.getProjectSystemId();
    if (!params['assigned_project_id']) return;
    let data = await $get('/ucenter/v2/device/plcenergyconservationbypidV3', params, true);
    return Service.handleCommonError(data)
}

// 获取空调节能概况
Service.getEnergyConservationByPIDMonthRange = async function (params = {}) {
    // 项目Id
    params['assigned_project_id'] = Service.getProjectSystemId();
    if (!params['assigned_project_id']) return;

    let data = await $get('/ucenter/v2/device/plcEnergyConservationByPIDMonthRangeV3', params, true);
    return Service.handleCommonError(data)
}

// 获取水泵节能概况
Service.getPumpsConservationByPIDMonthRange = async function (params = {}) {
    // 项目Id
    params['assigned_project_id'] = Service.getProjectSystemId();
    if (!params['assigned_project_id']) return;

    let data = await $get('/ucenter/v2/device/PumpsByPIDTimeRangeV3', params, true);
    return Service.handleCommonError(data)
}

// 获取水泵节能日概况
Service.getPumpStatisticByPIDTimeRange = async function (params = {}) {
    // 项目Id
    params['assigned_project_id'] = Service.getProjectSystemId();
    if (!params['assigned_project_id']) return;

    let data = await $get('/ucenter/v2/device/PumpStatisticByPIDTimeRangeV3', params, true);
    return Service.handleCommonError(data)
}

// 获取空调节能日概况
Service.getPLCStatisticByPIDTimeRange = async function (params = {}) {
    // 项目Id
    params['assigned_project_id'] = Service.getProjectSystemId();
    if (!params['assigned_project_id']) return;

    let data = await $get('/ucenter/v2/device/PLCStatisticByPIDTimeRangeV3', params, true);
    return Service.handleCommonError(data)
}


// 获取能耗总览
Service.getMonthElectricityByPID = async function (params = {}) {
    // 项目Id
    params['assigned_project_id'] = Service.getProjectSystemId();
    if (!params['assigned_project_id']) return;

    let data = await $get('/ucenter/v2/device/MonthElectricityByPIDV3', params, true);
    return Service.handleCommonError(data)
}

// plc运行时间配置
// 获取
Service.getPlcterminalbasicByPID = async function (params) {

    let data = await $get('/ucenter/v2/device/plcterminalbasic/tid', params, true);
    return Service.handleCommonError(data)
}

// 新增
Service.addPlcterminalbasicByPID = async function (params) {

    let data = await $post('/ucenter/v2/device/plcterminalbasic/add', params, true);
    return Service.handleCommonError(data)
}

// 修改
Service.editPlcterminalbasicByPID = async function (params) {

    let data = await $post('/ucenter/v2/device/plcterminalbasic/edit', params, true);
    return Service.handleCommonError(data)
}

// 删除
Service.delPlcterminalbasicByPID = async function (params) {

    let data = await $post('/ucenter/v2/device/plcterminalbasic/del', params, true);
    return Service.handleCommonError(data)
}

// PLC配置
// PLC设置导出
Service.getPlcExport = async function (params) {

    let data = await $get('/ucenter/v2/device/plcterminal/export', params, true);
    return Service.handleCommonError(data)
}

// 导入
Service.getPlcImport = async function (params) {

    let data = await $post('/ucenter/v2/device/plcterminal/inport', params, true);
    return Service.handleCommonError(data)
}
//导出报表
Service.getExport = async function (params) {
	let request = {}
	request['project_sys_id'] = Service.getProjectSystemId();
	request['terminal_id'] = params.terminal_id
	request['bill_type'] = params.bill_type
	request['from'] = params.from
	request['to'] = params.to
	
    let data = await $get('ucenter/v2/device/plc/bill', request, true);
    return Service.handleCommonError(data)
}